import { interruptActiveAudio } from "@memorang/ui/helpers/audio-focus";
import { useLocalSearchParams } from "expo-router";
import { useEffect } from "react";
import useSessionStore from "./useSessionStore";

/**
 * Stops whichever audio is currently playing (explanation TTS, listening
 * stimulus, recording playback) whenever the session moves to a different
 * item or block, and when the session screen unmounts.
 */
const useInterruptAudioOnItemChange = () => {
	const { index } = useLocalSearchParams<{ index: string }>();
	const currentBlockIndex = useSessionStore((s) => s.currentBlockIndex);

	// biome-ignore lint/correctness/useExhaustiveDependencies: interrupt on any item/block change
	useEffect(() => {
		interruptActiveAudio();
	}, [index, currentBlockIndex]);

	useEffect(() => {
		return () => {
			interruptActiveAudio();
		};
	}, []);
};

export default useInterruptAudioOnItemChange;
